import {useState, useEffect} from 'react';
import {orderBy} from 'lodash-es';
// state = { sortBy: "Codigo", desc: false }
// setSort = (idx) => () => {
//   this.setState(state => {
//     let desc = (state.sortBy === idx) ? !state.desc : false
//     return { sortBy: idx, desc }
//   })
// }
// render() {
//   const { sortBy, desc } = this.state;
//   const { data, dialog } = this.props;
//   const { empresas } = data;
//   let order = desc ? "desc" : "asc"
//   let list = orderBy(empresas, [sortBy], [order])
//   return (
//     <Provider>
//       <EmpresasUI
//         dialog={dialog}
//         list={list}
//         sort={{
//           set: this.setSort,
//           sortBy, desc
//         }}
//       />


const useSort = (data_=[], { by:by_=null, desc:desc_=false }={}) => {
  const [by, setBy] = useState(by_)
  const [desc, setDesc] = useState(desc_)
  const [data, setData] = useState(data_)
  const setSort = (idx) => () => {
    if (idx === by) {
      setDesc(!desc)
    } else {
      setBy(idx)
    }
    // setSort_(state => {
    //   let desc = (state.sortBy === idx) ? !state.desc : false
    //   return { by: idx, desc }
    // })
  }
  useEffect(() => {
    if (!!by && data.length) {
      let order = desc ? "desc" : "asc"
      setData(orderBy(data, [by], [order]))
    }
  }, [by, desc])
  let sort = { by, desc }
  return {
    sort,
    setSort,
    data,
  }
}

export default useSort
